module.exports = __webpack_public_path__ + "static/media/image_upload.19b89718.svg";